type Region = General.Region;
type UpperCaseRegion = General.UpperCaseRegion;
type Language = General.Language;

export const regionList: Region[] = [
  'id',
  'my',
  'th',
  'vn',
  'sg',
  'ph',
  'tw',
  'br',
  'cl',
  'co',
  'mx',
  'pl',
  'es',
  'fr',
  'gb',
  'us',
  'ar',
  'de',
  'it',
  'jp',
  'ie',
  'fr',
  'es',
  'kr',
  'nl',
  'be',
  'cz',
  'at',
  'gr',
  'pt',
  'hu',
];

export const isValidRegion = (
  region: string,
  list: General.Region[] = regionList,
): region is General.Region => list.includes(region as General.Region);

export const regionLabelMap: Record<Region, string> = {
  id: '印度尼西亚',
  my: '马来西亚',
  th: '泰国',
  vn: '越南',
  sg: '新加坡',
  ph: '菲律宾',
  tw: '台湾地区',
  br: '巴西',
  cl: '智利',
  co: '哥伦比亚',
  mx: '墨西哥',
  pl: '波兰',
  es: '西班牙',
  fr: '法国',
  gb: '英国',
  us: '美国',
  ar: '阿根廷',
  de: '德国',
  it: '意大利',
  jp: '日本',
  ie: '爱尔兰',
  kr: '韩国',
  nl: '荷兰',
  be: '比利时',
  cz: '捷克',
  at: '奥地利',
  gr: '希腊',
  pt: '葡萄牙',
  hu: '匈牙利',
};

export const regionShortLabelMap: Record<Region, string> = {
  id: '印尼',
  my: '马来',
  th: '泰国',
  vn: '越南',
  sg: '新加坡',
  ph: '菲律宾',
  tw: '台湾',
  br: '巴西',
  cl: '智利',
  co: '哥伦比亚',
  mx: '墨西哥',
  pl: '波兰',
  es: '西班牙',
  fr: '法国',
  gb: '英国',
  us: '美国',
  ar: '阿根廷',
  de: '德国',
  it: '意大利',
  jp: '日本',
  ie: '爱尔兰',
  kr: '韩国',
  nl: '荷兰',
  be: '比利时',
  cz: '捷克',
  at: '奥地利',
  gr: '希腊',
  pt: '葡萄牙',
  hu: '匈牙利',
};

export const regionEnLabelMap: Record<Region, string> = {
  id: 'Indonesia',
  my: 'Malaysia',
  th: 'Thailand',
  vn: 'Vietnam',
  sg: 'Singapore',
  ph: 'Philippines',
  tw: 'Taiwan China',
  br: 'Brazil',
  cl: 'Chile',
  co: 'Colombia',
  mx: 'Mexico',
  pl: 'Poland',
  es: 'Spain',
  fr: 'France',
  gb: 'United Kingdom',
  us: 'United States',
  ar: 'Argentina',
  de: 'Germany',
  it: 'Italy',
  jp: 'Japan',
  ie: 'Ireland',
  kr: 'Korea',
  nl: '',
  be: '',
  cz: '',
  at: '',
  gr: '',
  pt: '',
  hu: '',
};

export const regionLanguageMap: Record<Region, Language> = {
  id: 'id',
  my: 'en-US',
  th: 'th',
  vn: 'vi',
  sg: 'en-US',
  ph: 'en-US',
  tw: 'zh-TW',
  br: 'pt',
  cl: 'es',
  co: 'es',
  mx: 'es',
  pl: 'pl',
  es: 'es',
  fr: 'fr',
  gb: 'en-US',
  us: 'en-US',
  ar: 'es',
  de: 'de',
  it: 'it',
  jp: 'ja',
  ie: 'en-US',
  kr: 'ko',
  nl: 'nl',
  be: 'nl',
  cz: 'cs',
  at: 'de',
  gr: 'el',
  pt: 'pt',
  hu: 'hu',
};

export const regionTimeZoneMap: Record<Region, string> = {
  id: 'Asia/Jakarta',
  my: 'Asia/Kuching',
  th: 'Asia/Bangkok',
  vn: 'Asia/Ho_Chi_Minh',
  sg: 'Asia/Singapore',
  ph: 'Asia/Manila',
  tw: 'Asia/Taipei',
  br: 'America/Sao_Paulo',
  cl: 'America/Santiago',
  co: 'America/Bogota',
  mx: 'America/Mexico_City',
  pl: 'Europe/Warsaw',
  es: 'Europe/Madrid',
  fr: 'Europe/Paris',
  gb: 'Europe/London',
  us: 'America/Denver',
  ar: 'America/Argentina/Buenos_Aires',
  de: 'Europe/Berlin',
  jp: 'Asia/Tokyo',
  ie: 'Europe/Dublin',
  it: 'Europe/Rome',
  kr: 'Asia/Seoul',
  nl: 'Europe/Amsterdam',
  be: 'Europe/Brussels',
  cz: 'Europe/Prague',
  at: 'Europe/Vienna',
  gr: 'Europe/Athens',
  pt: 'Europe/Lisbon',
  hu: 'Europe/Budapest',
};

export const regionMonetaryUnitMap: Record<Region, string> = {
  id: 'Rp',
  my: 'RM',
  th: '฿',
  vn: '₫',
  sg: 'S$',
  ph: '₱',
  tw: 'NT$',
  br: 'R$',
  cl: 'CLP$',
  co: 'Col$',
  mx: 'MeX$',
  pl: 'zł',
  es: '€',
  fr: '€',
  gb: '$',
  us: '$',
  ar: 'ARS$',
  de: '',
  it: '',
  jp: '',
  ie: '',
  kr: '',
  nl: '€',
  be: '€',
  cz: 'Kč',
  at: '€',
  gr: '€',
  pt: '€',
  hu: 'Ft',
};

export const regionUpperCaseRegionMap: Record<Region, UpperCaseRegion> = {
  id: 'ID',
  my: 'MY',
  th: 'TH',
  vn: 'VN',
  sg: 'SG',
  ph: 'PH',
  tw: 'TW',
  br: 'BR',
  cl: 'CL',
  co: 'CO',
  mx: 'MX',
  pl: 'PL',
  es: 'ES',
  fr: 'FR',
  gb: 'GB',
  us: 'US',
  ar: 'AR',
  de: 'DE',
  it: 'IT',
  jp: 'JP',
  ie: 'IE',
  kr: 'KR',
  nl: 'NL',
  be: 'BE',
  cz: 'CZ',
  at: 'AT',
  gr: 'GR',
  pt: 'PT',
  hu: 'HU',
};

export const upperCaseRegionRegionMap = regionList.reduce<Partial<Record<UpperCaseRegion, Region>>>(
  (res, region) => {
    const { [region]: upperCaseRegion } = regionUpperCaseRegionMap;

    res[upperCaseRegion] = region;

    return res;
  },
  {},
) as Record<UpperCaseRegion, Region>;

export const regionBuyerDetailHostMap: Record<General.Region, string> = {
  id: 'https://shopee.co.id',
  tw: 'https://shopee.tw',
  vn: 'https://shopee.vn',
  my: 'https://shopee.com.my',
  sg: 'https://shopee.sg',
  th: 'https://shopee.co.th',
  ph: 'https://shopee.ph',
  br: 'https://shopee.com.br',
  mx: 'https://shopee.com.mx',
  co: 'https://shopee.com.co',
  cl: 'https://shopee.cl',
  pl: 'https://shopee.pl',
  es: 'https://es.xiapibuy.com',
  fr: 'https://fr.xiapibuy.com',
  gb: '',
  us: '',
  ar: '',
  de: '',
  it: '',
  jp: '',
  ie: '',
  kr: '',
  nl: '',
  be: '',
  cz: '',
  at: '',
  gr: '',
  pt: '',
  hu: '',
};

export const shopeeLocalSellerHostMap: Partial<Record<General.Region, string>> = {
  id: 'https://seller.shopee.co.id',
  vn: 'https://banhang.shopee.vn',
  my: 'https://seller.shopee.com.my',
  sg: 'https://seller.shopee.sg',
  th: 'https://seller.shopee.co.th',
  ph: 'https://seller.shopee.ph',
  br: 'https://seller.shopee.com.br',
  mx: 'https://seller.shopee.com.mx',
  co: 'https://seller.shopee.com.co',
  cl: 'https://seller.shopee.cl',
  pl: 'https://seller.shopee.pl',
};

export const lazadaSellerCenterHostMap: Partial<Record<General.UpperCaseRegion, string>> = {
  ID: 'https://sellercenter.lazada.co.id',
  MY: 'https://sellercenter.lazada.com.my',
  PH: 'https://sellercenter.lazada.com.ph',
  SG: 'https://sellercenter.lazada.sg',
  TH: 'https://sellercenter.lazada.co.th',
  VN: 'https://sellercenter.lazada.vn',
};

export const lazadaCrossSellerCenterHostMap: Partial<Record<General.UpperCaseRegion, string>> = {
  ID: 'https://sellercenter-id.lazada-seller.cn',
  MY: 'https://sellercenter-my.lazada-seller.cn',
  PH: 'https://sellercenter-ph.lazada-seller.cn',
  SG: 'https://sellercenter-sg.lazada-seller.cn',
  TH: 'https://sellercenter-th.lazada-seller.cn',
  VN: 'https://sellercenter-vn.lazada-seller.cn',
};

export type RateRegion = Exclude<General.UpperCaseRegion, 'TW'> | 'CN' | 'US';

export interface RegionFixedExchangeRateValue {
  shorthand: Exclude<Dashboard.CurrencyShorthand, 'RMB'>;
  rate: string;
  symbol: string;
  rateRule: string;
  region: RateRegion;
}
export const regionFixedExchangeRate: Partial<Record<RateRegion, RegionFixedExchangeRateValue>> = {
  CN: {
    symbol: '￥',
    shorthand: 'CNY',
    rateRule: '',
    rate: '1',
    region: 'CN',
  },
  ID: {
    symbol: 'Rp',
    shorthand: 'IDR',
    rateRule: 'CNY/IDR',
    rate: '2189.6',
    region: 'ID',
  },
  PH: {
    symbol: '₱',
    shorthand: 'PHP',
    rateRule: 'CNY/PHP',
    rate: '7.8700',
    region: 'PH',
  },
  TH: {
    symbol: '฿',
    shorthand: 'THB',
    rateRule: 'CNY/THB',
    rate: '4.5612',
    region: 'TH',
  },
  VN: {
    symbol: '₫',
    shorthand: 'VND',
    rateRule: 'CNY/VND',
    rate: '3480.1',
    region: 'VN',
  },
  SG: {
    symbol: 'S$',
    shorthand: 'SGD',
    rateRule: 'CNY/SGD',
    rate: '0.2091',
    region: 'SG',
  },
  MY: {
    symbol: 'RM',
    shorthand: 'MYR',
    rateRule: 'CNY/MYR',
    rate: '0.65546',
    region: 'MY',
  },
  MX: {
    symbol: 'Mex$',
    shorthand: 'MXN',
    rateRule: 'CNY/MXN',
    rate: '2.58',
    region: 'MX',
  },
  CL: {
    symbol: 'CLP$',
    shorthand: 'CLP',
    rateRule: 'CNY/CLP',
    rate: '124.69',
    region: 'CL',
  },
  CO: {
    symbol: 'Col$',
    shorthand: 'COP',
    rateRule: 'CNY/COP',
    rate: '570.51',
    region: 'CO',
  },
  BR: {
    symbol: 'R$',
    shorthand: 'BRL',
    rateRule: 'CNY/BRL',
    rate: '0.76',
    region: 'BR',
  },
  ES: {
    symbol: '€',
    shorthand: 'EUR',
    rateRule: 'CNY/EUR',
    rate: '0.1394',
    region: 'ES',
  },
  FR: {
    symbol: '€',
    shorthand: 'EUR',
    rateRule: 'CNY/EUR',
    rate: '0.1394',
    region: 'FR',
  },
  PL: {
    symbol: 'zł',
    shorthand: 'PLN',
    rateRule: 'CNY/PLN',
    rate: '0.63900',
    region: 'PL',
  },
  // TW: {
  //   symbol: 'NT$',
  //   shorthand: 'TWD',
  //   rateRule: 'CNY/TWD',
  //   rate: '4.3672',
  //   region: 'TW',
  // },
  US: {
    symbol: '$',
    shorthand: 'USD',
    rateRule: 'CNY/USD',
    rate: '0.1501',
    region: 'US',
  },
};

export const language2currencyMap: Record<
  General.SystemLanguage,
  RegionFixedExchangeRateValue | undefined
> = {
  'zh-CN': regionFixedExchangeRate.CN,
  'en-US': regionFixedExchangeRate.US,
  id: regionFixedExchangeRate.ID,
  th: regionFixedExchangeRate.TH,
  tl: regionFixedExchangeRate.PH,
  vi: regionFixedExchangeRate.VN,
  pt: regionFixedExchangeRate.BR,
  es: regionFixedExchangeRate.US,
};

export const translateLang2WhatsappLangMapping: Record<
  General.Language,
  WhatsappBusinessApi.Language
> = {
  'zh-CN': 'zh-CN',
  'en-US': 'en',
  id: 'id',
  pt: 'pt-BR',
  th: 'th',
  vi: 'vi',
  'zh-TW': 'zh-TW',
  tl: 'fil',
  es: 'es-ES',
  ms: 'ms',
  pl: 'pl',
  fr: 'fr',
  ar: 'es-ES',
};
